export const T = {
  nav: {
    home: { it: "Home", en: "Home" },
    menu: { it: "Menù", en: "Menu" },
    storia: { it: "La Storia", en: "The Story" },
    contatti: { it: "Contatti", en: "Contact" },
    reserve: { it: "Prenota", en: "Reserve" },
  },

  hero: {
    kicker: { it: "Bistrot · Siracusa", en: "Bistrot · Syracuse" },
    line1: { it: "Tradizione", en: "Tradition" },
    line2: { it: "che respira,", en: "that breathes," },
    line3: { it: "cucina che racconta.", en: "cuisine that speaks." },
    sub: {
      it: "Pranzo, cena, aperitivo, un calice, un cocktail: Trisé c'è sempre.",
      en: "Lunch, dinner, aperitivo, a glass of wine, a cocktail: Trisé is always here.",
    },
    ctaMenu: { it: "Scopri il menù", en: "Explore the menu" },
    ctaLunch: { it: "Menu pranzo", en: "Lunch menu" },
    ctaReserve: { it: "Prenota un tavolo", en: "Book a table" },
    scroll: { it: "Scorri", en: "Scroll" },
  },

  intro: {
    tag: { it: "Chi siamo", en: "Who we are" },
    body: {
      it: "Siamo la Sicilia autentica. Nel cuore di Siracusa, il nostro bistrot è un punto d'incontro tra passato e presente. Qui si mangia bene e ci si sente a casa: niente formalismi, solo il piacere sincero della condivisione.",
      en: "We are authentic Sicily. In the heart of Syracuse, our bistrot is a meeting point between past and present. Here you eat well and feel at home: no formalities, just the sincere pleasure of sharing.",
    },
    body2: {
      it: "Proponiamo una cucina siciliana contemporanea che segue il ritmo delle stagioni, valorizza i prodotti del territorio e reinterpreta le ricette popolari con un pizzico di creatività.",
      en: "We offer contemporary Sicilian cuisine that follows the rhythm of the seasons, celebrates local produce and reinterprets popular recipes with a pinch of creativity.",
    },
    body3: {
      it: "Non siamo un posto da selfie, siamo un luogo da vivere. Trisé è per chi cerca la Sicilia nei dettagli, lontano dai luoghi comuni. Per chi ama tornare dove ha mangiato bene, ma soprattutto si è sentito bene.",
      en: "We're not a place for selfies, we're a place to live. Trisé is for those who look for Sicily in the details, far from the clichés. For those who love to return where they ate well, but above all felt good.",
    },
  },

  pillars: {
    tag: { it: "Tre anime, un solo tavolo", en: "Three souls, one table" },
    heading: { it: "Trisé", en: "Trisé" },
    intro: {
      it: "Da “Trisemu” — in siciliano “siamo in tre”. Abbiamo lasciato solo la radice più viva: Trisé. Tre pilastri che si incontrano per un'esperienza autentica.",
      en: "From “Trisemu” — Sicilian for “we are three”. We kept only the most alive root: Trisé. Three pillars meeting for an authentic experience.",
    },
    story: {
      heading: { it: "L'Origine di Trisé", en: "The origin of Trisé" },
      headingPrefix: { it: "L'Origine di", en: "The origin of" },
      trioHeading: { it: "Tre sono i nostri pilastri", en: "Three are our pillars" },
      trio: [
        { it: "Stagionalità", en: "Seasonality" },
        { it: "Territorio", en: "Local produce" },
        { it: "Creatività", en: "Creativity" },
      ],
      closing: {
        it: "La nostra proposta segue il ciclo della natura, trasformandosi al ritmo delle materie prime e della fantasia di chi cucina. Tre elementi non mancano mai: intensità, sapore e genuinità. Dalla memoria dei primi piatti alla rivisitazione estrosa dei secondi, fino alla carezza finale dei nostri dessert.",
        en: "Our offering follows the cycle of nature, changing with the rhythm of the ingredients and the imagination of those who cook. Three elements are never missing: intensity, flavour and honesty. From the memory of the first courses to the inventive twist of the mains, all the way to the final caress of our desserts.",
      },
      homeTitle: {
        it: "Mettiti comodo: vogliamo farti sentire a casa.",
        en: "Make yourself comfortable: we want you to feel at home.",
      },
      p1: {
        it: "Tutto nasce da un'espressione schietta, antica come la nostra terra: “Trisemu”, che in siciliano significa “siamo in tre”. Un'affermazione semplice, legata alla condivisione e alla forza del fare le cose insieme.",
        en: "It all begins with a frank expression, as ancient as our land: “Trisemu”, Sicilian for “we are three” — a simple statement tied to sharing and to the strength of doing things together.",
      },
      p2: {
        it: "Abbiamo scelto di spogliare questa parola del superfluo, lasciando solo la sua radice più viva e popolare: Trisé. Da questa sottrazione è nata una parola nuova, e con essa un nuovo modo di intenderci e di stare a tavola.",
        en: "We chose to strip this word of the superfluous, leaving only its most alive and popular root: Trisé. From this subtraction a new word was born, and with it a new way of understanding one another at the table.",
      },
      p3: {
        it: "Trisé non è solo un nome, ma un'idea di cucina: tre anime, tre pilastri — territorio, stagionalità e creatività — che si incontrano per regalare un'esperienza autentica, contemporanea e creativa.",
        en: "Trisé is not just a name, but an idea of cuisine: three souls, three pillars — terroir, seasonality and creativity — meeting to offer an authentic, contemporary and creative experience.",
      },
    },
    list: [
      {
        num: "01",
        it: "Territorio",
        en: "Terroir",
        body_it: "Ingredienti selezionati che raccontano i sapori autentici della nostra terra.",
        body_en: "Selected ingredients that tell the authentic flavours of our land.",
      },
      {
        num: "02",
        it: "Stagionalità",
        en: "Seasonality",
        body_it: "La proposta segue il ciclo della natura, trasformandosi al ritmo delle materie prime.",
        body_en: "The menu follows the cycle of nature, changing with the rhythm of raw ingredients.",
      },
    ],
  },

  marquee: { it: "BISTROT · CORSO GELONE 99 · SIRACUSA · ", en: "BISTROT · CORSO GELONE 99 · SYRACUSE · " },

  gallery: {
    tag: { it: "Dalla nostra cucina", en: "From our kitchen" },
    heading: { it: "Il piacere della tavola", en: "The pleasure of the table" },
    cta: { it: "Vedi il menù completo", en: "See the full menu" },
  },

  home_location: {
    tag: { it: "Dove siamo", en: "Where we are" },
    heading: { it: "Al centro di tutto, lontani dal solito.", en: "At the centre of everything, far from the ordinary." },
    body: {
      it: "Ci trovi nel cuore pulsante di Siracusa, in Corso Gelone 99: un punto di riferimento strategico, a pochissimi passi dal Parco Archeologico della Neapolis, dal fascino del Teatro Greco e dalla maestosità del Santuario della Madonna delle Lacrime.",
      en: "You'll find us in the beating heart of Syracuse, at Corso Gelone 99: a strategic landmark, steps from the Neapolis Archaeological Park, the allure of the Greek Theatre and the majesty of the Sanctuary of the Madonna delle Lacrime.",
    },
    cta: { it: "Come raggiungerci", en: "How to reach us" },
  },

  menu_page: {
    tag: { it: "Menù estivo", en: "Summer menu" },
    heading: { it: "Menù", en: "Menu" },
    intro: {
      it: "Una cucina che segue le stagioni.",
      en: "Cuisine that follows the seasons.",
    },
    reserveNote: { it: "Vuoi un tavolo? Scrivici su WhatsApp o chiamaci.", en: "Want a table? Message us on WhatsApp or call us." },
  },

  storia_page: {
    tag: { it: "La Storia", en: "The Story" },
    heading1: { it: "L'origine di Trisé", en: "The origin of Trisé" },
    p1: {
      it: "Tutto nasce da un'espressione schietta, antica come la nostra terra: “Trisemu”, che in siciliano significa “siamo in tre”. Un'affermazione semplice, legata alla condivisione e alla forza del fare le cose insieme.",
      en: "It all begins with a frank expression, as ancient as our land: “Trisemu”, which in Sicilian means “we are three”. A simple statement, tied to sharing and the strength of doing things together.",
    },
    p2: {
      it: "Abbiamo scelto di spogliare questa parola del superfluo, lasciando solo la sua radice più viva e popolare: Trisé. Da questa sottrazione è nata una parola nuova, e con essa un nuovo modo di intenderci e di stare a tavola.",
      en: "We chose to strip this word of the superfluous, leaving only its most alive and popular root: Trisé. From this subtraction a new word was born, and with it a new way of understanding one another at the table.",
    },
    p3: {
      it: "Trisé non è solo un nome, ma un'idea di cucina: tre anime, tre pilastri — territorio, stagionalità e creatività — che si incontrano per regalare un'esperienza autentica e contemporanea.",
      en: "Trisé is not just a name, but an idea of cuisine: three souls, three pillars — terroir, seasonality and creativity — meeting to offer an authentic and contemporary experience.",
    },
    heading2: { it: "La sala e la veranda", en: "The room & the veranda" },
    p4: {
      it: "Gli ospiti possono accomodarsi nella sala interna o nell'ampia veranda climatizzata, impreziosita da piante mediterranee, un ulivo e comodi divanetti — per vivere un'esperienza di gusto e relax in un'atmosfera elegante e informale.",
      en: "Guests can settle in the interior room or in the large climate-controlled veranda, adorned with Mediterranean plants, an olive tree and comfortable sofas — for an experience of taste and relaxation in an elegant, informal atmosphere.",
    },
    heading3: { it: "Al centro di Siracusa", en: "In the centre of Syracuse" },
    p5: {
      it: "In Corso Gelone 99, un punto di riferimento strategico a pochi passi dal Teatro Greco, dal Parco Archeologico della Neapolis, dal Museo Paolo Orsi e dal Santuario della Madonna delle Lacrime. Aperti a pranzo, aperitivo e cena.",
      en: "At Corso Gelone 99, a strategic landmark steps from the Greek Theatre, the Neapolis Archaeological Park, the Paolo Orsi Museum and the Sanctuary of the Madonna delle Lacrime. Open for lunch, aperitivo and dinner.",
    },
    closing: { it: "Mettiti comodo: vogliamo solo farti sentire a casa.", en: "Make yourself comfortable: we just want you to feel at home." },
  },

  contatti_page: {
    tag: { it: "Contatti", en: "Contact" },
    heading: { it: "Vieni a trovarci", en: "Come and find us" },
    address_label: { it: "Indirizzo", en: "Address" },
    phone_label: { it: "Telefono", en: "Phone" },
    hours_label: { it: "Orari di apertura", en: "Opening hours" },
    social_label: { it: "Seguici", en: "Follow us" },
    reserve_heading: { it: "Prenota il tuo tavolo", en: "Book your table" },
    reserve_body: {
      it: "Accettiamo prenotazioni. Il modo più veloce è scriverci su WhatsApp o chiamarci direttamente.",
      en: "We accept reservations. The fastest way is to message us on WhatsApp or call us directly.",
    },
    whatsapp_btn: { it: "Scrivici su WhatsApp", en: "Message us on WhatsApp" },
    call_btn: { it: "Chiama ora", en: "Call now" },
    closed: { it: "Chiuso", en: "Closed" },
    services_tag: { it: "Servizi", en: "Amenities" },
    services_heading: { it: "Tutto quello che offriamo", en: "Everything we offer" },
  },

  hours: [
    { it: "Lunedì", en: "Monday", closed: true },
    { it: "Martedì", en: "Tuesday", slots: "12:30–15:00 · 19:00–23:00" },
    { it: "Mercoledì", en: "Wednesday", slots: "12:30–15:00 · 19:00–23:00" },
    { it: "Giovedì", en: "Thursday", slots: "12:30–15:00 · 19:00–23:00" },
    { it: "Venerdì", en: "Friday", slots: "12:30–15:00 · 19:00–23:00" },
    { it: "Sabato", en: "Saturday", slots: "12:30–15:00 · 19:00–23:00" },
    { it: "Domenica", en: "Sunday", slots: "19:00–23:00" },
  ],

  services: [
    { icon: "Accessibility", it: "Accessibile in sedia a rotelle", en: "Wheelchair accessible" },
    { icon: "Dog", it: "Cani ammessi", en: "Dogs welcome" },
    { icon: "Baby", it: "Adatto ai bambini", en: "Kid friendly" },
    { icon: "Music", it: "Musica dal vivo", en: "Live music" },
    { icon: "Wine", it: "Vini & cocktail", en: "Wine & cocktails" },
    { icon: "CreditCard", it: "Carte & NFC", en: "Cards & NFC" },
    { icon: "ParkingCircle", it: "Parcheggio gratuito", en: "Free parking" },
    { icon: "Wifi", it: "Wi-Fi gratuito", en: "Free Wi-Fi" },
    { icon: "Leaf", it: "Opzioni vegetariane & vegane", en: "Vegetarian & vegan options" },
    { icon: "ShoppingBag", it: "Asporto & consegna", en: "Takeaway & delivery" },
    { icon: "Coffee", it: "Aperitivo & happy hour", en: "Aperitivo & happy hour" },
    { icon: "Heart", it: "LGBTQ+ friendly", en: "LGBTQ+ friendly" },
  ],

  footer: {
    tagline: { it: "Siamo la Sicilia autentica.", en: "We are authentic Sicily." },
    hours_short: { it: "Mar–Sab · 12:30–15:00 e 19:00–23:00 · Dom · 19:00–23:00 · Lun chiusi", en: "Tue–Sat · 12:30–15:00 & 19:00–23:00 · Sun · 19:00–23:00 · Mon closed" },
    rights: { it: "Tutti i diritti riservati.", en: "All rights reserved." },
    reviews: { it: "Recensioni", en: "Reviews" },
  },
};
